import React                                    from 'react'

import {
   Grid,
   TextField,
}                                               from '@material-ui/core'
import PropTypes                                from 'prop-types'
import SearchUserIdUsernameComponent            from '../Components/SearchUserIdUsernameComponent.js'

/* This componnent makes use of an empty tag since even a <div> </div> was causing issues with page placement. */

const SearchUserIdUsernameDisplayComponent = ( { handleSearch, label, name, setCurrentSearch, userId, searchListToDisplay } ) => {
      
   return (
      <Grid container>
         <SearchUserIdUsernameComponent handleSearch={handleSearch} label={label} name={name} setCurrentSearch={setCurrentSearch} userId={userId} />
         <Grid item xs={3} style={{marginLeft: '1rem', height: '250px', overflow: 'scroll', border: '2px solid darkgray', borderRadius: '0.5rem', padding: '1rem' }}>
            {searchListToDisplay}
         </Grid>
      </Grid>
   )
}

SearchUserIdUsernameDisplayComponent.propTypes = {
   handleSearch:                                PropTypes.func,
   label:                                       PropTypes.string,
   name:                                        PropTypes.string,
   setCurrentSearch:                            PropTypes.func,
   userId:                                      PropTypes.string,
   searchListToDisplay:                         PropTypes.array
}

export default SearchUserIdUsernameDisplayComponent
